module.exports = "/static/assets/d7dd1b18c09f179f5a20859d1d88a7c5.png";